import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API } from '../../ApiNames';

 export const DoctorDatsssS = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchRevoke = (revoke: any) => ({
    type: 'FETCH_Revoke_SUCCESS',
    payload: revoke,
});
export const fetchApproveSuccess = (approvedata: any) => ({
    type: 'FETCH_Approve_SUCCESS',
    payload: approvedata,
});
export const fetchRejectedSuccess = (reject: any) => ({
    type: 'FETCH_Rejecte_SUCCESS',
    payload: reject,
});





export const DoctorData = (DoctorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,doctorid:DoctorID};
            const apiname = Admin_API.Doc_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(DoctorDatsssS(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const ApproveData = (DoctorID:any,plan:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:7,doctorid:DoctorID,plan:plan};
            const apiname = Admin_API.Doc_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchApproveSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const rejected = (DoctorID:any,rejectreason:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,doctorid:DoctorID,reason:rejectreason};
            const apiname = Admin_API.Doc_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchRejectedSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const RevokeData = (DoctorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:6,doctorid:DoctorID};
            const apiname = Admin_API.Doc_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchRevoke(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


